import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { Icon, Tooltip } from "@h3/antd-vue";
import { SystemControl } from "../controls/system-control";
import { userApi } from "@cloudpivot/api";
import { utils } from "@cloudpivot/common";
const DateHandle = utils.DateHandle;
import { StaffSelectorMapping } from '@cloudpivot/form/src/common/components/form-staff-selector/staff-selector-mappings';
let PcSystemControl = class PcSystemControl extends SystemControl {
    // ftext: string = ''
    created() {
        if (this.control.key === "createdTime" || this.control.key === "modifiedTime") {
            if (typeof this.control.value === 'string') {
                if (Array.isArray(this.control.value.split(" ")) && this.control.value.split(" ").length < 2) {
                    this.control.value = new Date();
                }
            }
            if (!this.control.value) {
                this.control.value = new Date();
            }
            // this.ftext = DateHandle.dateFormatApm(new Date(this.control.value), this.control.options.format1)
        }
        this.getUserInfo();
    }
    getUserInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // 修改人、创建人 支持属性映射功能-- 获取当前人的用户信息
            let mappings = this.control.options.mappings || "";
            let value = this.control.value;
            let query = this.$route.query;
            if (mappings && value && Array.isArray(value)) {
                // 流程表单状态不执行映射
                if (query.isWorkFlow && query.isWorkFlow === 'true' || query.edit) {
                    return;
                }
                if (this.control.writable) {
                    let { data } = yield userApi.getUserInfo(value[0].id);
                    this.ctrl.value = [data];
                    StaffSelectorMapping.mappingOperate(this.ctrl.value, mappings, this);
                }
            }
        });
    }
};
PcSystemControl = tslib_1.__decorate([
    Component({
        name: "system-control",
        components: {
            AIcon: Icon,
            ATooltip: Tooltip
        }
    })
], PcSystemControl);
export default PcSystemControl;
